import React, { useEffect, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

const AdminTest = () => {
  const { isAuthenticated, user, loading, token } = useAuth()
  const [debugInfo, setDebugInfo] = useState({})

  useEffect(() => {
    const tokenFromStorage = localStorage.getItem('token')
    setDebugInfo({
      timestamp: new Date().toISOString(),
      loading,
      isAuthenticated,
      user: user ? { ...user } : null,
      tokenExists: !!token,
      tokenFromStorage: !!tokenFromStorage,
      tokenMatch: token === tokenFromStorage
    })
  }, [loading, isAuthenticated, user, token])

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Admin Authentication Test</h1>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">Debug Information</h2>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto">
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </div>

        {loading && (
          <div className="mt-4 p-4 bg-yellow-100 border border-yellow-400 rounded">
            Loading authentication state...
          </div>
        )}

        {!loading && !isAuthenticated && (
          <div className="mt-4 p-4 bg-red-100 border border-red-400 rounded">
            Not authenticated - should redirect to login
          </div>
        )}

        {!loading && isAuthenticated && !user?.isAdmin && (
          <div className="mt-4 p-4 bg-orange-100 border border-orange-400 rounded">
            Authenticated but not admin
          </div>
        )}

        {!loading && isAuthenticated && user?.isAdmin && (
          <div className="mt-4 p-4 bg-green-100 border border-green-400 rounded">
            ✅ Authenticated admin user: {user.name} ({user.email})
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminTest
